/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import { css } from '@emotion/react'
import { indexOf } from 'lodash'

import { ImageInline } from '../image'
import { InlineVideo } from '../video'

const Graphic = (props) => {
  const { image, imageType, mux, ...otherProps } = props

  return (
    <div
      sx={{
        maxWidth: '540px',
        mx: 'auto',
      }}
    >
      {imageType === 'animation' && mux ? (
        <InlineVideo
          mux={mux}
          placeholder={{ src: null, width: 100, height: 100 }}
        />
      ) : image ? (
        <ImageInline image={image} />
      ) : null}
    </div>
  )
}

export default Graphic
